/**
 * Required-field balloons: “Please fill out this field.”
 * - Shows on every empty required field at add-to-cart
 * - Still required after fill/upload then clear/delete
 * - Suppresses Easify “This is a required option” text
 */
(function () {
  var MSG = 'Please fill out this field.';
  var busy = false;
  var balloonTimers = [];

  function isVisible(el) {
    if (!el || el.disabled) return false;
    if (el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    var host = el.closest('[hidden]');
    if (host && host !== el) return false;
    var wrap = el.closest('.onhow-studio-upload-wrapper, [data-uc-design-request]');
    if (wrap && wrap.hidden) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return !!(el.offsetParent || el.getClientRects().length);
  }

  function productRoot() {
    return document.querySelector('product-info') || document.querySelector('.product') || document;
  }

  function optionTitleNode(block) {
    return (
      block.querySelector(
        ':scope > .tpo_label, :scope > [class*="tpo_label"], :scope > [class*="option-label"], :scope > legend, :scope > .form__label, .tpo_label, [class*="tpo_label"], legend, .form__label'
      ) || block
    );
  }

  function labelText(block) {
    var label = optionTitleNode(block);
    return String((label && label.textContent) || '');
  }

  function normLabel(block) {
    return labelText(block)
      .replace(/\*/g, '')
      .replace(/required/gi, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isRequiredBlock(block) {
    var text = labelText(block);
    if (text.indexOf('*') !== -1) return true;
    if (block.querySelector('[required], [aria-required="true"]')) return true;
    if (
      block.getAttribute('data-required') === 'true' ||
      block.getAttribute('data-required') === '1' ||
      block.querySelector('[data-required="true"], [data-required="1"]')
    ) {
      return true;
    }
    // Brand / Color in the side-by-side row are always required on customs
    if (block.closest('.uc-brand-color-row')) {
      var n = normLabel(block);
      if (n === 'brand' || n.indexOf('brand') === 0) return true;
      if (n === 'color' || n === 'colour' || n.indexOf('color') === 0 || n.indexOf('colour') === 0) return true;
    }
    return false;
  }

  function optionBlocks(root) {
    var list = Array.prototype.slice.call(
      (root || productRoot()).querySelectorAll(
        '.tpo_option-set, [class*="tpo_option-set"], [class*="option-set"], [class*="option-wrapper"], [class*="tpo_row"], .easify-product-options > div, .uc-brand-color-row > *'
      )
    );
    // Prefer leaf blocks so Brand+Color row is not treated as one field
    return list.filter(function (block, i, arr) {
      if (block.classList && block.classList.contains('uc-brand-color-row')) return false;
      for (var j = 0; j < arr.length; j++) {
        if (i === j) continue;
        if (block !== arr[j] && block.contains(arr[j])) return false;
      }
      return true;
    });
  }

  function controlForBlock(block) {
    var select = block.querySelector('select');
    if (select) return select;
    var textarea = block.querySelector('textarea');
    if (textarea) return textarea;
    var text = block.querySelector(
      'input[type="text"], input[type="email"], input[type="tel"], input[type="number"]'
    );
    if (text) return text;
    var radio = block.querySelector('input[type="radio"], input[type="checkbox"]');
    if (radio) return radio;
    return block;
  }

  function blockEmpty(block) {
    var control = controlForBlock(block);
    if (!control || control === block) {
      var radios = block.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        for (var i = 0; i < radios.length; i++) if (radios[i].checked) return false;
        return true;
      }
      var checks = block.querySelectorAll('input[type="checkbox"]');
      if (checks.length) {
        for (var j = 0; j < checks.length; j++) if (checks[j].checked) return false;
        return true;
      }
      return false;
    }
    if (control.type === 'radio' || control.type === 'checkbox') {
      var group = (control.form || document).querySelectorAll(
        'input[type="' + control.type + '"][name="' + control.name + '"]'
      );
      for (var g = 0; g < group.length; g++) if (group[g].checked) return false;
      return true;
    }
    return !String(control.value || '').trim();
  }

  function clearUploadState(wrap) {
    if (!wrap) return;
    var file = wrap.querySelector('.onhow-studio-upload-input, input[type="file"]');
    if (file) file.value = '';
    var hidden = document.getElementById('onhow-upload-url');
    if (hidden) hidden.value = '';
    var injected = document.getElementById('onhow-studio-upload-hidden');
    if (injected && injected.parentNode) injected.parentNode.removeChild(injected);
    var preview = wrap.querySelector('.onhow-studio-upload-preview');
    var zone = wrap.querySelector('.onhow-studio-upload-zone');
    var img = wrap.querySelector('.onhow-studio-upload-img');
    var cardName = wrap.querySelector('.onhow-studio-upload-card-name');
    var cardSize = wrap.querySelector('.onhow-studio-upload-card-size');
    if (img) img.removeAttribute('src');
    if (cardName) cardName.textContent = '';
    if (cardSize) cardSize.textContent = '';
    if (preview) preview.classList.add('onhow-studio-upload-hidden');
    if (zone) zone.classList.remove('onhow-studio-upload-hidden');
    wrap.setAttribute('data-uc-upload-has-file', '0');
  }

  function isTrustedUploadUrl(value) {
    var v = String(value || '').trim();
    if (!v || v.indexOf('https://') !== 0) return false;
    if (v.indexOf('blob:') === 0 || v.indexOf('data:') === 0) return false;
    return true;
  }

  function hasUploadFile(wrap) {
    var file = wrap && wrap.querySelector('.onhow-studio-upload-input, input[type="file"]');
    if (file && file.files && file.files[0] && file.files[0].size > 0) {
      wrap.setAttribute('data-uc-upload-has-file', '1');
      return true;
    }
    var injected = document.getElementById('onhow-studio-upload-hidden');
    if (injected && injected.files && injected.files[0] && injected.files[0].size > 0) {
      if (wrap) wrap.setAttribute('data-uc-upload-has-file', '1');
      return true;
    }
    var cartFile = document.getElementById('uc-design-upload-file');
    if (cartFile && cartFile.files && cartFile.files[0] && cartFile.files[0].size > 0) {
      if (wrap) wrap.setAttribute('data-uc-upload-has-file', '1');
      return true;
    }
    var hidden = document.getElementById('onhow-upload-url');
    if (hidden && isTrustedUploadUrl(hidden.value)) {
      if (wrap) wrap.setAttribute('data-uc-upload-has-file', '1');
      return true;
    }
    // Preview-only (blob/data URL) does not count — Admin never receives those.
    if (wrap) wrap.setAttribute('data-uc-upload-has-file', '0');
    return false;
  }

  function optionBlockFor(field) {
    if (!field || field.nodeType !== 1) return null;
    return (
      field.closest('.uc-brand-color-row > *') ||
      field.closest(
        '.tpo_option-set, [class*="tpo_option-set"], [class*="option-set"], [class*="option-wrapper"], .uc-design-request, .onhow-studio-upload-wrapper'
      )
    );
  }

  function isBrandOrColorBlock(block) {
    if (!block) return false;
    if (!block.closest('.uc-brand-color-row')) return false;
    var n = normLabel(block);
    if (n === 'brand' || n.indexOf('brand') === 0) return true;
    if (n === 'color' || n === 'colour' || n.indexOf('color') === 0 || n.indexOf('colour') === 0) return true;
    return false;
  }

  function findColorChartHelp(block) {
    if (!block) return null;
    var nodes = block.querySelectorAll('[class*="help"], .tpo_help, small, [class*="Help"], p, div, span');
    for (var i = 0; i < nodes.length; i++) {
      var t = String(nodes[i].textContent || '').toLowerCase();
      if (t.indexOf('color chart') !== -1 || t.indexOf('box above') !== -1) return nodes[i];
    }
    return (
      block.querySelector('[class*="help"], .tpo_help, small, [class*="Help"]') || null
    );
  }

  function anchorFor(field) {
    if (!field) return null;
    if (field.nodeType !== 1) return null;
    var wrap = field.closest && field.closest('.onhow-studio-upload-wrapper');
    if (wrap) return wrap.querySelector('.onhow-studio-upload-zone') || wrap;
    if (field.type === 'file') {
      var w = field.closest('.onhow-studio-upload-wrapper');
      return (w && w.querySelector('.onhow-studio-upload-zone')) || w || field;
    }
    if (field.type === 'radio' || field.type === 'checkbox') {
      return field.closest('.tpo_buttons-wrapper, .product-form__input, fieldset, [class*="tpo_option"]') || field;
    }
    try {
      var style = window.getComputedStyle(field);
      var rect = field.getBoundingClientRect();
      if (style.display === 'none' || style.visibility === 'hidden' || rect.width < 2 || rect.height < 2) {
        return (
          field.closest(
            '.onhow-studio-upload-zone, .uc-design-request, .product-form__input, .tpo_option-set, [class*="tpo_option-set"], [class*="option-wrapper"]'
          ) || field.parentElement
        );
      }
    } catch (e) {}
    return field;
  }

  function clearBalloons() {
    document.querySelectorAll('[data-uc-native-hint]').forEach(function (el) {
      el.remove();
    });
    balloonTimers.forEach(clearTimeout);
    balloonTimers = [];
  }

  function showInlineHint(field, block) {
    var tip = document.createElement('div');
    tip.setAttribute('data-uc-native-hint', '1');
    tip.className = 'uc-native-required-hint uc-native-required-hint--inline';
    tip.setAttribute('role', 'alert');
    tip.innerHTML =
      '<span class="uc-native-required-hint__icon" aria-hidden="true">!</span>' +
      '<span>' +
      MSG +
      '</span>';

    var control =
      (field && field.matches && field.matches('input, select, textarea') && field) ||
      controlForBlock(block);
    var help = findColorChartHelp(block);

    // Keep tip inside Color/Brand column: after the input, before color-chart help
    if (help && help.parentNode) {
      help.parentNode.insertBefore(tip, help);
    } else if (control && control.parentNode) {
      if (control.nextSibling) control.parentNode.insertBefore(tip, control.nextSibling);
      else control.parentNode.appendChild(tip);
    } else {
      block.appendChild(tip);
    }

    balloonTimers.push(
      setTimeout(function () {
        if (tip.parentNode) tip.remove();
      }, 4500)
    );
    return tip;
  }

  function showBalloon(field, opts) {
    opts = opts || {};
    var block = optionBlockFor(field);

    // Brand / Color: tip lives inside the option box (above color-chart help)
    if (block && isBrandOrColorBlock(block)) {
      if (opts.scroll) {
        try {
          (field || block).scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e) {}
      }
      return showInlineHint(field, block);
    }

    var anchor = anchorFor(field) || field;
    if (!anchor) return null;

    if (opts.scroll) {
      try {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (e) {}
    }

    var tip = document.createElement('div');
    tip.setAttribute('data-uc-native-hint', '1');
    tip.className = 'uc-native-required-hint';
    tip.setAttribute('role', 'alert');
    tip.innerHTML =
      '<span class="uc-native-required-hint__icon" aria-hidden="true">!</span>' +
      '<span>' +
      MSG +
      '</span>';
    document.body.appendChild(tip);

    function place() {
      if (!tip.parentNode || !anchor) return;
      var rect = anchor.getBoundingClientRect();
      if (rect.width < 1 && rect.height < 1) {
        var fallback =
          anchor.closest('.uc-brand-color-row > *, .tpo_option-set, [class*="tpo_option-set"], [class*="option-wrapper"]') ||
          anchor.parentElement;
        if (fallback) rect = fallback.getBoundingClientRect();
      }
      var tipW = tip.offsetWidth || 220;
      var left = rect.left + 8;
      left = Math.max(8, Math.min(left, window.innerWidth - tipW - 8));
      var top = rect.top + window.scrollY - tip.offsetHeight - 10;
      if (top < window.scrollY + 8) top = rect.bottom + window.scrollY + 8;
      tip.style.left = left + 'px';
      tip.style.top = top + 'px';
    }
    place();
    requestAnimationFrame(place);
    balloonTimers.push(setTimeout(place, 280));
    balloonTimers.push(setTimeout(place, 600));

    balloonTimers.push(
      setTimeout(function () {
        if (tip.parentNode) tip.remove();
      }, 4500)
    );
    return tip;
  }

  function isOptionUi(el) {
    if (!el || el.nodeType !== 1) return false;
    // Never hide Brand / Color / Size wrappers — Easify often sets data-error on the whole option
    if (el.querySelector('select, textarea, input, .tpo_label, [class*="tpo_label"], label')) return true;
    if (el.matches('select, textarea, input, label, .tpo_option-set, [class*="tpo_option-set"], [class*="option-wrapper"]')) {
      return true;
    }
    if (el.closest('.uc-brand-color-row, .uc-option-stack')) {
      if (el.matches('[class*="help"], small') || /required/i.test(el.textContent || '')) return false;
    }
    return false;
  }

  function restoreHiddenOptionFields() {
    // Undo accidental hide from older clearEasifyErrors (data-error on whole Color/Brand block)
    document.querySelectorAll('.uc-brand-color-row > *, .uc-option-stack > *').forEach(function (el) {
      if (el.style.display !== 'none') return;
      if (el.querySelector('select, textarea, input')) el.style.display = '';
    });
  }

  function clearEasifyErrors() {
    restoreHiddenOptionFields();
    document.querySelectorAll('[data-error]').forEach(function (el) {
      el.removeAttribute('data-error');
      if (isOptionUi(el)) return;
      if (/required/i.test(el.textContent || '')) {
        el.textContent = '';
        el.innerHTML = '';
        el.style.display = 'none';
      }
    });
    document.querySelectorAll('.tpo_error, [class*="tpo_error"], [class*="required-error"]').forEach(function (el) {
      if (isOptionUi(el)) return;
      if (/required/i.test(el.textContent || '')) {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  function collectEmptyRequired() {
    var empties = [];
    var seen = [];

    function push(control) {
      if (!control) return;
      for (var i = 0; i < seen.length; i++) if (seen[i] === control) return;
      seen.push(control);
      empties.push(control);
    }

    // Design notes
    var notes = document.querySelector('[data-uc-design-notes]');
    var notesRoot = notes && notes.closest('[data-uc-design-request]');
    if (notes && notesRoot && !notesRoot.hidden && !notes.disabled) {
      if (!String(notes.value || '').trim()) push(notes);
    }

    // Upload (including after delete)
    var upload = document.querySelector('.onhow-studio-upload-wrapper');
    if (upload && !upload.hidden) {
      if (!hasUploadFile(upload)) {
        push(upload.querySelector('.onhow-studio-upload-input, input[type="file"]') || upload);
      }
    }

    // Easify blocks with * (leaf blocks only — Brand and Color are separate)
    optionBlocks(productRoot()).forEach(function (block) {
      if (!isRequiredBlock(block)) return;
      if (!isVisible(block) && !block.querySelector('select, textarea, input')) return;
      if (!blockEmpty(block)) return;
      push(controlForBlock(block));
    });

    // Explicit Brand | Color row pass (guarantees Color balloon even if Easify markup is odd)
    document.querySelectorAll('.uc-brand-color-row > *').forEach(function (block) {
      if (!isRequiredBlock(block)) return;
      if (!blockEmpty(block)) return;
      push(controlForBlock(block));
    });

    // Native required attrs
    productRoot()
      .querySelectorAll('input[required], select[required], textarea[required]')
      .forEach(function (field) {
        if (field.disabled) return;
        if (field.type === 'file') return;
        if (field.type === 'radio') {
          var group = (field.form || document).querySelectorAll('input[type="radio"][name="' + field.name + '"]');
          var checked = false;
          for (var k = 0; k < group.length; k++) if (group[k].checked) checked = true;
          if (!checked) push(field);
          return;
        }
        if (!String(field.value || '').trim()) push(field);
      });

    return empties;
  }

  function validate(opts) {
    opts = opts || {};
    clearEasifyErrors();
    clearBalloons();
    var empties = collectEmptyRequired();
    if (!empties.length) return true;
    empties.forEach(function (field, index) {
      showBalloon(field, { scroll: index === 0 });
    });
    return false;
  }

  function onAdd(event) {
    if (busy) return;
    busy = true;
    try {
      if (!validate({ fromAdd: true })) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        setTimeout(clearEasifyErrors, 0);
        setTimeout(clearEasifyErrors, 50);
        setTimeout(clearEasifyErrors, 200);
        return false;
      }
    } finally {
      busy = false;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      // Upload remove → treat as empty again
      var removeBtn = event.target.closest('.onhow-studio-upload-remove');
      if (removeBtn) {
        var wrap = removeBtn.closest('.onhow-studio-upload-wrapper');
        setTimeout(function () {
          clearUploadState(wrap);
        }, 0);
        return;
      }

      var btn = event.target.closest(
        '[type="submit"][name="add"], .product-form__submit, button[name="add"], button[type="submit"]'
      );
      if (!btn) return;
      if (!btn.closest('product-info, product-form, .product, form[action*="/cart/add"]')) return;
      onAdd(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
      onAdd(event);
    },
    true
  );

  // After upload completes, mark filled
  document.addEventListener('onhowUploadComplete', function () {
    var wrap = document.querySelector('.onhow-studio-upload-wrapper');
    if (wrap) wrap.setAttribute('data-uc-upload-has-file', '1');
    clearBalloons();
  });

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t) return;
    if (t.matches('input[type="file"]') && t.closest('.onhow-studio-upload-wrapper')) {
      var wrap = t.closest('.onhow-studio-upload-wrapper');
      if (t.files && t.files.length) {
        wrap.setAttribute('data-uc-upload-has-file', '1');
        clearBalloons();
      } else {
        clearUploadState(wrap);
      }
    }
  });

  // If user clears text / empties a required field, balloons clear; add-to-cart will recheck
  document.addEventListener('input', function (event) {
    var t = event.target;
    if (!t || !t.matches('input, select, textarea')) return;
    try {
      t.setCustomValidity('');
    } catch (e) {}
    clearEasifyErrors();
    if (String(t.value || '').trim()) clearBalloons();
  });

  // Blur: if a required field was filled then emptied, show its balloon
  document.addEventListener(
    'blur',
    function (event) {
      var t = event.target;
      if (!t || !t.matches('input, select, textarea')) return;
      if (t.type === 'file') return;
      setTimeout(function () {
        var empties = collectEmptyRequired();
        for (var i = 0; i < empties.length; i++) {
          if (empties[i] === t || (empties[i].contains && empties[i].contains(t))) {
            clearBalloons();
            showBalloon(empties[i], { scroll: false });
            break;
          }
        }
      }, 0);
    },
    true
  );

  if (typeof MutationObserver !== 'undefined') {
    var obsTimer = null;
    new MutationObserver(function () {
      clearTimeout(obsTimer);
      obsTimer = setTimeout(clearEasifyErrors, 10);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-error', 'class']
    });
  }

  window.__ucValidateProductRequired = validate;
})();
